import { Profile } from '../types';

const getBillingDetails = (profile?: Profile) => {
  if (!profile) {
    return {};
  }

  const { city, country, email, firstName, lastName, phone, street, zip } =
    profile;
  return {
    address: {
      city,
      country,
      line1: street,
      postal_code: zip,
    },
    email,
    name: `${firstName} ${lastName}`,
    phone,
  };
};

export default getBillingDetails;
